<template>
  <b-card class="no-border animated fadeIn">
    <div class="item-header clearfix mb-3">
      <h5 class="pull-left mb-0 mt-2"><b-badge :variant="badgeType">{{ statusText }}</b-badge> Prestart - {{ vehicleRegNo }}</h5>
    </div>
    <div class="list-group mb-2">
      <b-nav>
        <b-nav-item @click="section = ''"           :active="section === ''"           >Detail</b-nav-item>
        <b-nav-item @click="section = 'questions'"  :active="section === 'questions'"  >Questions</b-nav-item>
      </b-nav>
    </div>
    <router-view></router-view>
  </b-card>
</template>
<script>
export default {
  name: 'prestart_detail',
  data() {
    const routes = this.$route.fullPath.split('/');
    return {
      section: routes[4] || '',
      badgeType: '',
      statusText: '',
      vehicleRegNo: '',
    };
  },
  created() {
    const { answerSetId } = this.$route.params;
    this.$store.commit('question_prestart/SET_DETAIL_ID', answerSetId);
    this.$store.commit('SET_BREADCRUMB_ITEMS', [
      { to: '', name: 'Home' },
      { to: 'question_prestart', name: 'Vehicle Checklist' },
      { to: answerSetId, name: 'Detail' },
    ]);
    this.$store.dispatch('question_prestart/LOAD_DETAIL_DATA');
  },
  computed: {
    detailedInfo() {
      return this.$store.getters['question_prestart/get_detail_data'];
    },
  },
  watch: {
    section(newSection) {
      const { answerSetId } = this.$route.params;
      this.$router.push(`/question_prestart/${answerSetId}/${newSection}`);
    },
    detailedInfo(info) {
      const { status, vehicle } = info;
      this.badgeType = status === 'SUCCESS' ? 'success' : 'danger';
      this.statusText = status === 'SUCCESS' ? 'PASS' : 'FAIL';
      this.vehicleRegNo = vehicle.reg_no || 'UNKNOWN';
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/pages/question_prestart/Detail.vue